import { render, staticRenderFns } from "./model-from.vue?vue&type=template&id=233bd168&scoped=true&"
import script from "./model-from.vue?vue&type=script&lang=js&"
export * from "./model-from.vue?vue&type=script&lang=js&"
import style0 from "./model-from.vue?vue&type=style&index=0&id=233bd168&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233bd168",
  null
  
)

export default component.exports